import { useRouteError } from 'react-router';

const ErrorPage = () => {
	let error = useRouteError();
	return <div>Error: {error.message}</div>;
};

export default ErrorPage;
